import React from 'react';

export const SmallRedAlertMessage = ({ children, ...props }) => {
  return <small style={{ color: 'red', display: 'block' }} {...props}>{children}</small>;
};